import styled from 'styled-components'

export default styled.div`
  margin: 5px 0;
  min-height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
`
